import { FilterBreadcrumbProps } from './types'
import { useFilterBreadcrumbData } from './hooks/useFilterBreadcrumbData'
import { ScrollNav, FilterChipGroup, FilterSectionSingle } from './components'

const FILTERS_LABEL = 'Filtros Aplicados:'

export function FilterBreadcrumb({ filters, onRemoveFilter }: FilterBreadcrumbProps) {
  const { territories, contexts, topics, partners, sources, hasAnyFilter } =
    useFilterBreadcrumbData(filters)

  if (!hasAnyFilter) return null

  return (
    <ScrollNav>
      <span className="font-semibold text-xs text-gray-900 whitespace-nowrap">
        {FILTERS_LABEL}
      </span>
      <FilterChipGroup
        items={territories}
        label="Territórios"
        filterType="territories"
        onRemoveFilter={onRemoveFilter}
      />
      <FilterChipGroup
        items={topics}
        label="Tópico"
        filterType="topics"
        onRemoveFilter={onRemoveFilter}
      />
      <FilterChipGroup
        items={contexts}
        label="Contexto"
        filterType="contexts"
        onRemoveFilter={onRemoveFilter}
      />
      <FilterChipGroup
        items={partners}
        label="Parceiros"
        filterType="partners"
        onRemoveFilter={onRemoveFilter}
      />
      <FilterChipGroup
        items={sources}
        label="Fonte"
        filterType="sources"
        onRemoveFilter={onRemoveFilter}
      />
      {filters.favorited !== undefined && (
        <FilterSectionSingle
          label="Favoritos"
          value={filters.favorited ? 'Sim' : 'Não'}
          onRemove={() => onRemoveFilter('favorited')}
        />
      )}
      {filters.created_by && (
        <FilterSectionSingle
          label="Enviado por"
          value={filters.created_by === 'AGENT' ? 'Agent' : 'Platform'}
          onRemove={() => onRemoveFilter('created_by')}
        />
      )}
    </ScrollNav>
  )
}
